// extracted by mini-css-extract-plugin
export default {"emailMessage":"SendReceiptAfterCheckout_emailMessage__aFTAK"};